export default {
  frontRoutes: [
    {
      path: '/index/rec-news/:id',
      name: 'IndexRecommendNews',
      component: () => import(/* webpackChunkName: "news" */ '../views/news/NewsRecommend.vue'),
    },
    {
      path: '/news',
      name: 'News',
      component: () => import(/* webpackChunkName: "news" */ '../views/news/News.vue'),
    },
    {
      path: '/news/:id',
      name: 'NewsShow',
      component: () => import(/* webpackChunkName: "news" */ '../views/news/NewsShow.vue'),
    },
  ],
  memberRoutes: [],
};
